import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const viewTestMasterApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}test-master/${params.id}`,
        method: "get",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUserToken()}`
        }
    })
    return response.data
}

export default viewTestMasterApi